export default __webpack_public_path__ + "static/shareMyToolbox_Web_Logo-9ec2dfe99f3992895463b1c5c4343413.svg";